<template>
    <div>
        <v-menu
                offset-y
                :close-on-content-click="false"
                ref="settingsMenu"
        >
            <template v-slot:activator="{ on }">
                <v-btn
                        text
                        class="text-capitalize"
                        v-on="on"
                >
                    {{ $t('scenarioMenu.parameters') }}
                </v-btn>
            </template>
            <v-list dense>

                <v-menu
                        v-for="group in configGroups"
                        :key="'groupMenuConfigs'+group.name"
                        offset-x
                        :open-on-hover="true"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-item
                                v-on="on"
                                @click=""
                        >
                            <v-list-item-title class="font-weight-regular">
                                {{groupDisplayName(group)}}
                            </v-list-item-title>
                            <v-list-item-action>
                                <v-icon>mdi-menu-right</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                    <v-list dense>
                        <v-tooltip
                                right
                                v-for="config in group.contents"
                                :key="group.name+config.name"
                                max-width="400"
                                color="#333"
                        >
                            <template v-slot:activator="{ on }">
                                <v-list-item
                                        class="body-2"
                                        @click="startEdit(config.name)"
                                        v-on="on"
                                >
                                    <v-list-item-content>
                                        {{paramDisplayName(config)}}
                                    </v-list-item-content>

                                    <v-list-item-action class="font-weight-bold pl-2">
                                        <settings-item-value :config-name="config.name"/>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                            <span>{{paramDescr(config)}}</span>
                        </v-tooltip>


                    </v-list>

                </v-menu>

                <v-tooltip
                        v-if="0"
                        right
                        max-width="400"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-item v-on="on" @click="openResetConfirmation">
                            <v-list-item-title class="font-weight-regular">
                                {{ $t('scenarioMenu.resetAll') }}
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                    <span>
                        Reset all this scenario's settings to their default values.
                    </span>
                </v-tooltip>


            </v-list>
        </v-menu>

        <v-dialog v-model="showDialog" max-width="400" persistent>
            <v-card v-if="showDialog">
              <v-card-title>
                        <v-icon left>mdi-playlist-edit</v-icon>
                        {{paramDisplayName(selectedConfigData)}}

              </v-card-title>

                <div v-if="institutionIsConsortium">
                    <v-alert
                            color="warning"
                            text
                            icon="mdi-alert"
                    >
                            <p class="font-weight-bold">{{ $t('params.couldTakeAWhile') }}</p>
                            <p>
                                {{ $t('params.recalcWarning') }}
                            </p>
                        <p>{{ $t('params.recalcEmailNotice', { email: userEmail }) }}</p>
                    </v-alert>

                </div>

                <v-card-text class="pt-4">
                    <div>
                        <v-text-field
                                v-if="selectedConfigData.display==='dollars'"
                                outlined
                                type="number"
                                :disabled="savingConfig"
                                @keydown.enter="saveEdit"
                                :prefix="publisherCurrencySymbol"
                                v-model="selectedConfigValue"
                        />
                        <v-text-field
                                v-if="selectedConfigData.display==='percent'"
                                outlined
                                type="number"
                                :disabled="savingConfig"
                                @keydown.enter="saveEdit"
                                suffix="%"
                                v-model="selectedConfigValue"
                        />
                        <v-text-field
                                v-if="selectedConfigData.display==='number'"
                                outlined
                                type="number"
                                :disabled="savingConfig"
                                @keydown.enter="saveEdit"
                                v-model="selectedConfigValue"
                        />
                        <v-switch
                                v-if="selectedConfigData.display==='boolean'"
                                color="primary"
                                :disabled="savingConfig"
                                v-model="selectedConfigValue"
                                :label="paramDisplayName(selectedConfigData)"
                        />
                    </div>
                    <div class="descr">
                        {{paramDescr(selectedConfigData)}}
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn depressed @click="cancelEdit">{{ $t('common.cancel') }}</v-btn>
                    <v-btn
                            depressed
                            @click="saveEdit"
                            :loading="savingConfig"
                            color="primary"
                    >
                        {{ (institutionIsConsortium) ? $t('params.saveAndWait') : $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showResetDialog" max-width="400" persistent>
            <v-card v-if="showResetDialog">
                <v-card-title class="headline">
                    {{ $t('params.confirmReset') }}
                </v-card-title>
                <v-card-text class="pt-4">
                    <div>
                        {{ $t('params.confirmResetText') }}
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn depressed
                           @click="confirmReset"
                           color="primary"
                           :loading="savingReset"
                    >
                        {{ $t('params.yesResetAll') }}
                    </v-btn>
                    <v-btn depressed @click="showResetDialog=false">{{ $t('common.cancel') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    import appConfigs from "../../appConfigs";
    import SettingsItemValue from "../Settings/SettingsItemValue";

    export default {
        name: "ScenarioMenuSettings",
        components: {
            SettingsItemValue,
        },
        data: () => ({
            selectedConfigValue: null,
            showDialog: false,
            showResetDialog: false,
            selectedConfigName: null,
            savingConfig: false,
            savingReset: false,
            showSaveEditConfirmation: false,
        }),
        computed: {
            ...mapGetters([
                "publisherFilesDict",
                "institutionIsConsortium",
                "publisherCurrencySymbol",
                "userEmail",
            ]),
            configGroups: () => appConfigs.scenarioConfigGroups,
            selectedConfigData() {
                return appConfigs.scenarioConfigs[this.selectedConfigName]
            },
        },
        methods: {
            ...mapActions([
                "resetAllConfigs",
            ]),
            paramDisplayName(config) {
                const map = {
                    cost_alacart_increase: 'params.titleByTitleGrowth',
                    cost_content_fee_percent: 'params.contentFee',
                    cost_ill: 'params.illTransactionCost',
                    ill_request_percent_of_delayed: 'params.illRequestRate',
                    include_bronze: 'params.includeBronzeOA',
                    include_submitted_version: 'params.permitNonPeerReviewed',
                    include_social_networks: 'params.includeResearchGate',
                    weight_authorship: 'params.authorshipWeight',
                    weight_citation: 'params.citationWeight',
                }
                const key = config && map[config.name]
                return key ? this.$t(key) : (config && config.displayName)
            },
            paramDescr(config) {
                const map = {
                    cost_alacart_increase: 'params.titleByTitleGrowthDescr',
                    cost_content_fee_percent: 'params.contentFeeDescr',
                    cost_ill: 'params.illTransactionCostDescr',
                    ill_request_percent_of_delayed: 'params.illRequestRateDescr',
                    include_bronze: 'params.includeBronzeOADescr',
                    include_submitted_version: 'params.permitNonPeerReviewedDescr',
                    include_social_networks: 'params.includeResearchGateDescr',
                    weight_authorship: 'params.authorshipWeightDescr',
                    weight_citation: 'params.citationWeightDescr',
                }
                const key = config && map[config.name]
                return key ? this.$t(key) : (config && config.descr)
            },
            groupDisplayName(group) {
                const map = {
                    costs: 'params.costs',
                    ill: 'params.ill',
                    fulfillment: 'params.fulfillmentSources',
                    usageWeights: 'params.citationAuthorship',
                }
                const key = map[group.name]
                return key ? this.$t(key) : group.displayName
            },
            startEdit(configName) {
                this.$refs.settingsMenu.isActive = false
                this.showDialog = true
                this.selectedConfigName = configName
                this.selectedConfigValue = this.$store.getters.config(configName)
            },
            async saveEditHandler(){
                if (this.institutionIsConsortium){
                    if (this.showSaveEditConfirmation) {
                        return this.saveEdit()
                    }
                    else {
                        this.showSaveEditConfirmation = true
                        return
                    }
                }
                else {
                    return this.saveEdit()
                }

            },
            async saveEdit() {
                console.log("saving config edit", this.selectedConfigValue)
                this.savingConfig = true
                await this.$store.dispatch("setSelectedScenarioConfig", {
                    key: this.selectedConfigName,
                    value: this.selectedConfigValue,
                })
                this.cancelEdit()
                if (!this.institutionIsConsortium) {
                    this.$store.commit("snackbar", this.$t('params.settingUpdated'))
                }
            },
            cancelEdit() {
                this.selectedConfigName = null
                this.selectedConfigValue = null
                this.showDialog = false
                this.savingConfig = false
                this.showSaveEditConfirmation = false
            },
            async openResetConfirmation() {
                this.$refs.settingsMenu.isActive = false
                this.showResetDialog = true
            },
            async confirmReset() {
                this.savingReset = true
                await this.$store.dispatch("resetAllConfigs")
                this.savingReset = false
                this.showResetDialog = false
                this.$store.commit("snackbar", this.$t('params.settingsReset'))
            },
        }
    }
</script>

<style scoped>

</style>